import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./AuthContext";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";
import AdminProposalEditor from "./AdminProposalEditor";
import AdminAffiliates from "./AdminAffiliates";
import AdminStats from "./AdminStats";
import AdminTemplates from "./AdminTemplates";
import AdminPayments from "./AdminPayments";
import AdminEscapadas from "./AdminEscapadas";

function Guarded({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7] text-[#3A506B] italic">Cargando...</div>;
  }
  if (!user) return <AdminLogin />;
  return children;
}

export default function AdminRoutes() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Guarded><AdminDashboard /></Guarded>} />
        <Route path="/proposals/:id" element={<Guarded><AdminProposalEditor /></Guarded>} />
        <Route path="/templates" element={<Guarded><AdminTemplates /></Guarded>} />
        <Route path="/payments" element={<Guarded><AdminPayments /></Guarded>} />
        <Route path="/affiliates" element={<Guarded><AdminAffiliates /></Guarded>} />
        <Route path="/escapadas" element={<Guarded><AdminEscapadas /></Guarded>} />
        <Route path="/stats" element={<Guarded><AdminStats /></Guarded>} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </AuthProvider>
  );
}
